import { useTheme } from '@emotion/react'
import facepaint from 'facepaint'
import isMobile from 'ismobilejs'
import { FC, ReactNode } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, usePlayerState } from '../contexts/playerState'
import { mqs } from '../utils/theme'
import PlayerInfo from './PlayerInfo'
import SeekButtons from './SeekButtons'

const isMobileDevice = isMobile().phone

export interface PlayerOverlayProps {
  showInfo: boolean
  infoContent?: ReactNode
  showSeekButtons: boolean
}

const PlayerOverlay: FC<PlayerOverlayProps> = ({
  showSeekButtons,
  showInfo,
  infoContent,
}) => {
  const { isInitialized, playerInstance, isMediaControlOpen, isInfoOpen } =
    usePlayerState()
  const playerDispatch = useDispatch()

  const theme = useTheme()

  if (!isInitialized || !playerInstance || !theme?.colors) return null

  const {
    colors: { primary: primaryColor },
  } = theme

  return playerInstance?.el()
    ? ReactDOM.createPortal(
        <div
          css={wrapperStyle(!!isInfoOpen || !!isMediaControlOpen)}
          onClick={() => {
            isMobileDevice && playerDispatch({ type: 'closeMediaControl' })
          }}
          className="mcls-player-overlays-wrapper"
        >
          {showSeekButtons && <SeekButtons step={10} color={primaryColor} />}
          {showInfo && <PlayerInfo content={infoContent} />}
        </div>,
        playerInstance.el(),
      )
    : null
}

export default PlayerOverlay

const mq = facepaint([mqs.m])

const wrapperStyle = (isVisible: boolean) =>
  mq({
    background: isMobileDevice ? 'rgba(0,0,0,0.5)' : 'none',
    height: '100%',
    position: 'absolute' as const,
    width: '100%',
    top: 0,
    opacity: isVisible ? 1 : 0,
    zIndex: isVisible ? 'unset' : '-1',
    transition: 'opacity .3s',
    svg: {
      filter: isMobileDevice
        ? 'unset'
        : 'drop-shadow( 0px 2px 4px rgba(0,0,0,0.5))',
    },
  })
